import React from "react";
import style from "./style.module.css";

export interface UnorderedBulletGroupProps {
    bullets: string[]
}

export function UnorderedBulletGroup(props: UnorderedBulletGroupProps) {
    return (
        <ul className={style.bulletGroup}>
            {
                props.bullets.map((b: string, index: number) => {
                    return <li key={index} className={style.bullet}>{b}</li>;
                })
            }
        </ul>
    )
}